import { Navigation2 } from 'react-feather';
import Text from '../atoms/Text';

const TooltipWithArrow = ({ childNode, tooltipText, className, tooltipClass, arrowClass, onClick }) => (
    <div className={`relative group ${className}`} onClick={onClick} >
        {childNode}
        <div className={`absolute hidden group-hover:block bg-gray-600 right-[54px] ${tooltipClass} rounded top-0.5`}>
            <div className='relative'>
                <Text variant="caption" className="text-basic-100 px-2 py-1.5 z-[80] text-nowrap">{tooltipText}</Text>
                <Navigation2 size={20} className={`absolute -right-3 top-1 rotate-90 text-gray-600 fill-gray-600 z-0 ${arrowClass}`} />
            </div>
        </div>
    </div>
);
export default TooltipWithArrow;
